import { api } from '../api';

export const getConfig = (callback) => {
  let url = '/config';
  api.get(url).then(function (response) {
    callback(response.data.config ? response.data.config : []);
  }).catch(function (error) {
    console.log('getConfig => Error: ' + error);
    callback([]);
  });
}

export const getConfigAsync = async () => {
  let url = '/config';
  const response = await api.get(url)
  return response.data.config ? response.data.config : [];
}

export const updateConfigAsync = async (config) => {
  try {
    let url = '/config/1';

    let response = await api.put(url, {
      serieRps: config.serieRps,
      cnpjEmitente: config.cnpjEmitente,
      valorServico: config.valorServico,
      intervalo: config.intervalo,
      rpsHeader: config.rpsHeader,
      ticketFouter: config.ticketFouter,
      rpsFouter: config.rpsFouter,
      tolerancia: config.tolerancia,
      valorAdicional: config.valorAdicional,
    });
    return response.data.config ? response.data.config : [];
  } catch (error) {
    console.log("Update Config Error: ", error);
  }


}


export const updateConfig = (config, callback) => {
  let url = '/config/1';
  api.put(url, {
    ...config
  }).then(function (response) {
    console.log('updateConfig => response: ' + response.data);
    callback(response.data.config ? response.data.config : []);
  }).catch(function (error) {
    console.log('updateConfig => Error: ' + error);
    callback([]);
  });
}

const sizeLetter = {
  "small": "p",
  "medium": "m",
  "large": "g",
  "extra-large": "xg",

}


export const createConfigFile = (locker, portas) => {

  // console.log(JSON.stringify(locker));

  var mapeamento = [];
  var portasArray = [];

  for (let index = 0; index < portas.length; index++) {
    const porta = portas[index];

    mapeamento.push(
      {
      "porta": porta.slotName,
      "tamanho": sizeLetter[porta.size],
      "status": porta.status,
      "label": porta.label,
      "categoria": 0
    });
    
  }

  if (mapeamento.find(el => el.tamanho === sizeLetter["small"])) portasArray.push({
    "id": "p",
    "label": "Pequeno P"
  })

  if (mapeamento.find(el => el.tamanho === sizeLetter["medium"])) portasArray.push({
    "id": "m",
    "label": "Médio M"
  })

  if (mapeamento.find(el => el.tamanho === sizeLetter["large"])) portasArray.push({
    "id": "g",
    "label": "Grande G"
  })

  if (mapeamento.find(el => el.tamanho === sizeLetter["extra-large"])) portasArray.push({
    "id": "xg",
    "label": "Extra Grande GG"
  })



  var model = {
    "logradouro": `${locker?.address["Endereço"]} - ${locker?.address["UF"]}`,
    "cep": `${locker?.address["CEP"]}`,
    "modelo": "LK500",
    "numeroSerie": "000",
    "lockerId": locker?.id,
    "ambiente": "producao",
    "lockerIdPublico": locker?.publicLockerId,
    "CondominioIdPublico": locker?.name,
    // "USE_KERONG": true,
    // "KERONG_VERSION": 2,
    "blockStatusBar": false,
    "entrega": true,
    "escolhaOutros": "completo",
    "entregaCorreios": false,
    "entregaOutros": true,
    "loginSenhaEntregador": false,
    "idDestinatario": false,
    "categoria": false,
    "categorias": [
      {
        "id": 1,
        "label": "Categoria 1"
      },
      {
        "id": 2,
        "label": "Categoria 2"
      },
      {
        "id": 3,
        "label": "Categoria 3"
      },
      {
        "id": 4,
        "label": "Categoria 4"
      },
      {
        "id": 5,
        "label": "Categoria 5"
      }
    ],
    "portas": portasArray,
    "mapeamento": mapeamento
  }




  return model;

  // getConfigLocker(locker?.id, (response) => {

  //   var model = {};
  //   if (response) {
  //     model = {
  //       "logradouro": `${locker?.address["Endereço"]} - ${locker?.address["UF"]}`,
  //       "cep": `${locker?.address["CEP"]}`,
  //       "modelo": "LK500",
  //       "numeroSerie": "000",
  //       "lockerId": locker?.id,
  //       "ambiente": "producao",
  //       "lockerIdPublico": locker?.publicLockerId,
  //       "CondominioIdPublico": locker?.name,
  //       ...response,
  //       "categorias": [
  //         {
  //           "id": 1,
  //           "label": "Categoria 1"
  //         },
  //         {
  //           "id": 2,
  //           "label": "Categoria 2"
  //         },
  //         {
  //           "id": 3,
  //           "label": "Categoria 3"
  //         },
  //         {
  //           "id": 4,
  //           "label": "Categoria 4"
  //         },
  //         {
  //           "id": 5,
  //           "label": "Categoria 5"
  //         }
  //       ],
  //       "portas": portasArray,
  //       "mapeamento": mapeamento
  //     }
  //   } else {
  //     model = {
  //       "logradouro": `${locker?.address["Endereço"]} - ${locker?.address["UF"]}`,
  //       "cep": `${locker?.address["CEP"]}`,
  //       "modelo": "LK500",
  //       "numeroSerie": "000",
  //       "lockerId": locker?.id,
  //       "ambiente": "producao",
  //       "lockerIdPublico": locker?.publicLockerId,
  //       "CondominioIdPublico": locker?.name,
  //       "categorias": [
  //         {
  //           "id": 1,
  //           "label": "Categoria 1"
  //         },
  //         {
  //           "id": 2,
  //           "label": "Categoria 2"
  //         },
  //         {
  //           "id": 3,
  //           "label": "Categoria 3"
  //         },
  //         {
  //           "id": 4,
  //           "label": "Categoria 4"
  //         },
  //         {
  //           "id": 5,
  //           "label": "Categoria 5"
  //         }
  //       ],
  //       "portas": portasArray,
  //       "mapeamento": mapeamento
  //     }
  //   }

  //   return model;


  // }


}